 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"styles","8":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~a362a8b4","12":"vendors~AuthNew~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mo~a17b1a1c","13":"vendors~AuthNew~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~a69d551e","15":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","16":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","17":"vendors~AuthNew~Cigarette~ClientFormContainer~client~hotel_checkout~hotels~order~order_changing_requ~b5f5baf1","19":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","20":"authVendor","22":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","25":"vendors~AuthNew~Cigarette~ClientFormContainer~modern_desktop_home~modern_mobile_home~tinkoff_iframe","26":"Header~pay_card~sbp~t_pay","27":"vendors~Cigarette~about~header_app~tinkoff_iframe","28":"vendors~Header~about~header_app~wishlist","29":"vendors~Cigarette~EmptySearch~tinkoff_iframe","30":"vendors~Cigarette~HotelNotice~tinkoff_iframe","31":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","32":"vendors~Header~about~header_app","34":"AuthNew~ClientFormContainer","35":"FiltersPanel","36":"Map~YandexMapsSearch","38":"vendors~AuthNew~ClientFormContainer","39":"vendors~Cigarette~tinkoff_iframe","41":"AboutRoomPopup","42":"AndroidIcon","43":"AuthNew","44":"Cigarette","45":"ClientFormContainer","46":"EmptyFiltration","47":"EmptyMap","48":"EmptySearch","49":"ExpensiveHotelsPopup","50":"FiltersPanelMobile","51":"FlightFail","52":"FlightsItem","53":"Header","54":"HeaderAuth","55":"HotelNotice","56":"IosIcon","57":"Map","58":"MountainsContainer","59":"NpsForm","60":"OperatorsStatuses","61":"PriceChart","62":"SeamlessTBankAuth","63":"SearcherEmptyHotel","64":"SimilarPackagesContainer","65":"Subscribe","66":"ToAppgallery","67":"ToRustore","68":"YandexHotelMap","69":"YandexMapCheckout","70":"YandexMapsSearch","93":"sigmaInit","99":"vendors~AboutRoomPopup","100":"vendors~HeaderAuth","101":"vendors~Subscribe","108":"vendors~sigmaInit"}[chunkId]||chunkId) + ".__" + {"2":"e40709baa5e1eeac2828","8":"34a66e7081ae0b25471c","12":"47fd06660d4056d3ce8f","13":"591171d9e0f82fdfb02f","15":"bf38a9432116d5b36318","16":"5eab2ee6caf10ebed317","17":"7e9165b905e13cbe027b","19":"9b978595f5a89c5c5b47","20":"26e7d15260f707ffa8f3","22":"0e739b8cafe9f8227e97","25":"1b8887ee8e6283ab14de","26":"4389be0eb7ca36dfa42d","27":"a389adaf47bd48f254fc","28":"d35999e2855078f4f222","29":"9d5b8bc55a9648d3e302","30":"941a24c62f42b564ee31","31":"43661fc9ac7e2b894101","32":"b4f17d1fd63d0585cd0b","34":"dd9c82393d1bcc50a431","35":"ec376c165390412102b7","36":"881c8b3c2fcbf29e652e","38":"ab0dc3830571ca24eac0","39":"4893639cf730d66539c0","41":"8ceb3470b64b5c810167","42":"6552c60ed42553341472","43":"e0462a8db9430bc3e797","44":"42724a26fd7d66b0f783","45":"39707c313d98f8f6ebb0","46":"7358ef9c8609df562dde","47":"664b2eb9cbd91bd5f099","48":"823dbec5652fda55acda","49":"bd75f91f66bd19b03aa9","50":"4a7ab94a37d70f3ebc14","51":"0089d3a77d3fa96588b3","52":"416c8ca70de777249565","53":"4b8c415c863366d744c0","54":"8bc13c28c65514e44bea","55":"5f1a2c041654656bb60d","56":"198fdfe4a89d76caff3f","57":"8b4870f532105b1220ee","58":"6f47b7e1f196fff6f69a","59":"0798f1e9b51259822651","60":"eb20be6382e7eba87ae6","61":"e060c24175852ae93414","62":"1f93a793b0008aa0311d","63":"2d8b37c7b0d306c1178e","64":"1c2419d67f6dc408e84c","65":"cbc0247e27160c7dbdfe","66":"8db942b5dfa39074b3f7","67":"8d3d4155edfbdd653fc7","68":"c51c0c88a9e7288bf1ed","69":"8130bcb22d1a59820efd","70":"cb9881215d4c2a82b9ea","93":"2e2eff088f69c8b85efb","99":"cef68cb36bb4a6a76bcf","100":"66d430cd157443a0d8b2","101":"7aa7cd56ec1dc3898332","108":"f7bac342c5fe5a82771d"}[chunkId] + ".prod.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"34":1,"35":1,"36":1,"43":1,"47":1,"48":1,"49":1,"51":1,"53":1,"54":1,"57":1,"60":1,"61":1,"63":1,"68":1,"69":1,"70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"styles","8":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~a362a8b4","12":"vendors~AuthNew~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mo~a17b1a1c","13":"vendors~AuthNew~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~a69d551e","15":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","16":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","17":"vendors~AuthNew~Cigarette~ClientFormContainer~client~hotel_checkout~hotels~order~order_changing_requ~b5f5baf1","19":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","20":"authVendor","22":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","25":"vendors~AuthNew~Cigarette~ClientFormContainer~modern_desktop_home~modern_mobile_home~tinkoff_iframe","26":"Header~pay_card~sbp~t_pay","27":"vendors~Cigarette~about~header_app~tinkoff_iframe","28":"vendors~Header~about~header_app~wishlist","29":"vendors~Cigarette~EmptySearch~tinkoff_iframe","30":"vendors~Cigarette~HotelNotice~tinkoff_iframe","31":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","32":"vendors~Header~about~header_app","34":"AuthNew~ClientFormContainer","35":"FiltersPanel","36":"Map~YandexMapsSearch","38":"vendors~AuthNew~ClientFormContainer","39":"vendors~Cigarette~tinkoff_iframe","41":"AboutRoomPopup","42":"AndroidIcon","43":"AuthNew","44":"Cigarette","45":"ClientFormContainer","46":"EmptyFiltration","47":"EmptyMap","48":"EmptySearch","49":"ExpensiveHotelsPopup","50":"FiltersPanelMobile","51":"FlightFail","52":"FlightsItem","53":"Header","54":"HeaderAuth","55":"HotelNotice","56":"IosIcon","57":"Map","58":"MountainsContainer","59":"NpsForm","60":"OperatorsStatuses","61":"PriceChart","62":"SeamlessTBankAuth","63":"SearcherEmptyHotel","64":"SimilarPackagesContainer","65":"Subscribe","66":"ToAppgallery","67":"ToRustore","68":"YandexHotelMap","69":"YandexMapCheckout","70":"YandexMapsSearch","93":"sigmaInit","99":"vendors~AboutRoomPopup","100":"vendors~HeaderAuth","101":"vendors~Subscribe","108":"vendors~sigmaInit"}[chunkId]||chunkId) + "." + {"2":"3af713dca33677e9d010","8":"d41d8cd98f00b204e980","12":"d41d8cd98f00b204e980","13":"d41d8cd98f00b204e980","15":"d41d8cd98f00b204e980","16":"d41d8cd98f00b204e980","17":"d41d8cd98f00b204e980","19":"d41d8cd98f00b204e980","20":"d41d8cd98f00b204e980","22":"d41d8cd98f00b204e980","25":"d41d8cd98f00b204e980","26":"d41d8cd98f00b204e980","27":"d41d8cd98f00b204e980","28":"d41d8cd98f00b204e980","29":"d41d8cd98f00b204e980","30":"d41d8cd98f00b204e980","31":"d41d8cd98f00b204e980","32":"d41d8cd98f00b204e980","34":"23caeea5191dc186822a","35":"cda3a38be2bc039e1f3e","36":"e7838e262e95328a1d69","38":"d41d8cd98f00b204e980","39":"d41d8cd98f00b204e980","41":"d41d8cd98f00b204e980","42":"d41d8cd98f00b204e980","43":"8b56781ad92a57b73497","44":"d41d8cd98f00b204e980","45":"d41d8cd98f00b204e980","46":"d41d8cd98f00b204e980","47":"67d7082c4792b03f0807","48":"7bc690fbfb444b4fb1b5","49":"9686519f282e3233d6e6","50":"d41d8cd98f00b204e980","51":"3d5c7660f989b289df97","52":"d41d8cd98f00b204e980","53":"8777bae75ff33809aaef","54":"e2dc08d21432f13fd3cc","55":"d41d8cd98f00b204e980","56":"d41d8cd98f00b204e980","57":"10dcb55c3c7ae5da89f7","58":"d41d8cd98f00b204e980","59":"d41d8cd98f00b204e980","60":"a65265f17a8153dfeb55","61":"4e7d0822a16063d2594e","62":"d41d8cd98f00b204e980","63":"a60208ae14d613f1fd1a","64":"d41d8cd98f00b204e980","65":"d41d8cd98f00b204e980","66":"d41d8cd98f00b204e980","67":"d41d8cd98f00b204e980","68":"05caa9d97f0d66d5cb8f","69":"0593c4412a54f0e09b2e","70":"6db49fca7fc02b2cb0dd","93":"d41d8cd98f00b204e980","99":"d41d8cd98f00b204e980","100":"d41d8cd98f00b204e980","101":"d41d8cd98f00b204e980","108":"d41d8cd98f00b204e980"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 3 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 3 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          setTimeout(function() {
 				            var cacheBust = 'cache-bust=true' + retryAttemptString;
 				            var retryScript = loadScript(
 				              jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				              retries - 1
 				            );
 				            document.head.appendChild(retryScript);
 				          }, 0);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 3);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.cdn.level.travel/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpLtModules"] = window["wpJsonpLtModules"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
